import React from "react"

import HeaderComponent from "./header-component"

class HeaderContainer extends React.Component {

	render() {
		return (
			<HeaderComponent {...this.props} />
		)
	}

}

export default HeaderContainer



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/revenues/header-container.js